import { type RouteRecordRaw } from 'vue-router'

import { FeatureFlags } from '@/plugins/featureFlags'

/**
 * Feature flag to enable the new unified Pay view (labor summary + timesheets)
 * instead of the separate timesheets view.
 *
 * Set in Unleash as: hermes.pay
 * Local override: VITE_FF_HERMES_PAY=true
 */
const PAY_VIEW_FLAG_NAME = 'hermes.pay'

export const staffRouter: RouteRecordRaw[] = [
  {
    async beforeEnter() {
      // Enable MSW mocking for staff routes in development mode
      if (
        import.meta.env.MODE === 'development' &&
        import.meta.env.VITE_ENABLE_MOCKS === 'true'
      ) {
        const { startMockWorker, isMockWorkerStarted } =
          await import('@/mocks/browser')
        if (!isMockWorkerStarted()) {
          await startMockWorker()
        }
      }
    },

    children: [
      {
        component: async () => import('../views/BrandStaffMembersView.vue'),
        meta: {
          authZ: ({ user }) => user.can('read', 'user.staff'),
          permissions: [{ operation: 'read', resource: 'user.staff' }],
          scopes: ['users:staff:read'],
          title: 'staff-members',
        },
        name: 'brand.staff.members',
        path: 'members',
      },
      {
        component: async () => import('../views/BrandStaffJobsView.vue'),
        meta: {
          authZ: ({ user }) => user.can('read', 'employment.jobs'),
          permissions: [{ operation: 'read', resource: 'employment.jobs' }],
          scopes: ['employment:jobs:read'],
          title: 'staff-jobs',
        },
        name: 'brand.staff.jobs',
        path: 'jobs',
      },
      {
        component: async () =>
          FeatureFlags.isEnabled(PAY_VIEW_FLAG_NAME)
            ? import('../views/PayView.vue')
            : import('../views/StaffTimesheetsView.vue'),
        meta: {
          authZ: ({ user }) => user.can('read', 'employment.shifts'),
          scopes: ['employment:shifts:read'],
          title: FeatureFlags.isEnabled(PAY_VIEW_FLAG_NAME)
            ? 'staff-pay'
            : 'staff-timesheets',
        },
        name: 'brand.staff.pay',
        path: 'pay',
      },
    ],
    path: 'staff',
  },
]
